import React from 'react';
import { Section } from './ui/Section';
import { BookOpenIcon, ClockIcon, MessageSquareIcon, ShieldCheckIcon, LayoutTemplateIcon } from 'lucide-react';
export function WhatsIncluded() {
  return <Section className="bg-amber-50/50" data-id="element-177">
      <div className="text-center mb-16" data-id="element-178">
        <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-6" data-id="element-179">
          Qué te llevas exactamente
        </h2>
        <p className="text-lg text-stone-600" data-id="element-180">
          Todo en español claro. Sin tecnicismos. Sin relleno.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-181">
        <div className="bg-white p-8 rounded-2xl shadow-sm border border-stone-100 md:col-span-2 flex flex-col md:flex-row items-start md:items-center gap-6" data-id="element-182">
          <div className="bg-amber-100 p-4 rounded-xl text-amber-700" data-id="element-183">
            <LayoutTemplateIcon className="h-8 w-8" data-id="element-184" />
          </div>
          <div data-id="element-185">
            <h3 className="text-xl font-bold text-stone-900 mb-2" data-id="element-186">
              Prompt Base Universal (copiar/pegar)
            </h3>
            <p className="text-stone-600" data-id="element-187">
              La plantilla maestra para cualquier tarea. Solo rellenas los
              huecos y funciona.
            </p>
          </div>
        </div>

        {[{
        icon: ClockIcon,
        title: '3 Rutinas de 10 minutos',
        items: ['Plan del día + prioridades', 'Mensajes y ventas sin sonar desesperado', 'Claridad mental + decisiones']
      }, {
        icon: MessageSquareIcon,
        title: '10 Prompts Imprescindibles',
        items: ['Listos para usar', 'Biblioteca extra por situación', 'WhatsApp, ofertas, seguimiento']
      }, {
        icon: ShieldCheckIcon,
        title: 'Control de Daños',
        items: ['Privacidad y seguridad', 'Cómo verificar datos', "Evitar respuestas 'inventadas'"]
      }, {
        icon: BookOpenIcon,
        title: 'Guía PDF Completa',
        items: ['Lectura rápida', 'Ejemplos reales', 'Acceso de por vida']
      }].map((card, i) => <div key={i} className="bg-white p-8 rounded-2xl shadow-sm border border-stone-100" data-id="element-188">
            <div className="flex items-center gap-4 mb-6" data-id="element-189">
              <div className="bg-stone-100 p-3 rounded-lg text-stone-700" data-id="element-190">
                <card.icon className="h-6 w-6" data-id="element-191" />
              </div>
              <h3 className="text-lg font-bold text-stone-900" data-id="element-192">{card.title}</h3>
            </div>
            <ul className="space-y-3" data-id="element-193">
              {card.items.map((item, j) => <li key={j} className="flex items-start text-stone-600 text-sm" data-id="element-194">
                  <span className="mr-2 text-amber-500" data-id="element-195">•</span>
                  {item}
                </li>)}
            </ul>
          </div>)}
      </div>
    </Section>;
}